import { render } from "./My.vue?vue&type=template&id=6374e070&scoped=true"
import script from "./My.vue?vue&type=script&lang=js"
export * from "./My.vue?vue&type=script&lang=js"

import "./My.vue?vue&type=style&index=0&id=6374e070&scoped=true&lang=css"

import exportComponent from "/home/django/v1/mintit-engineer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6374e070"]])

export default __exports__